var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2196 3.95742C18.4275 3.44609 18.3087 2.85742 17.9228 2.46641C17.5368 2.07539 16.9558 1.95508 16.4511 2.16563L1.52254 8.35313C0.920313 8.60234 0.581027 9.24688 0.704018 9.89141C0.827009 10.5359 1.38683 11 2.03571 11H9.5V18.5625C9.5 19.2199 9.95804 19.7828 10.5942 19.9117C11.2304 20.0406 11.8665 19.6926 12.1125 19.0824L18.2196 3.95742Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/viewMore.e109db98705568b9f5f8699ee94e5ed4.svg";
export { ForwardRef as ReactComponent };